import { ACTIONS as classDetilsActions } from 'actions/class-status';
import { ACTIONS as homeDetailsActions } from 'actions/home-details';
import { ACTIONS as logoutActions } from 'actions/logout';
import moment from 'moment';
import { errors } from 'redux-rest-reducer';

export const initialState = null;

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === classDetilsActions.GET_SUCCESS) {
    const {
      value: { class_status: classStatus, teacher },
    } = payload;
    const { next_class_in: nextClassIn, elapsed_time: elapsedTime } = classStatus || {};

    return {
      ...state,
      ...classStatus,
      ...teacher,
      nextClassTime:
        nextClassIn && nextClassIn > 0
          ? moment().add(nextClassIn, 'seconds').toDate()
          : undefined,
      classStartedTime:
        elapsedTime && elapsedTime > 0
          ? moment().subtract(elapsedTime, 'seconds').toDate()
          : undefined,
      first_name: '',
      classHomeLoadedAtleastOnce: true,
    };
  }

  if (type === homeDetailsActions.GET_SUCCESS) {
    const {
      value: { student, extra_fields: extraFields },
    } = payload;
    const { name: studentName } = student || {};

    return {
      ...state,
      ...extraFields,
      ...student,
      student_name: studentName,
    };
  }

  if (type === logoutActions.POST_SUCCESS || type === errors[401]) {
    return initialState;
  }

  return state;
}
